import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["other"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, FormControl, InputLabel, Typography } from '@mui/material';
import { formatISO } from 'date-fns';
import * as A from 'fp-ts/Array';
import { flow, pipe } from 'fp-ts/function';
import * as NEA from 'fp-ts/NonEmptyArray';
import { useState } from 'react';
import { Translation, useTranslation } from 'react-i18next';
import { Badge } from '../badge';
import BadgeFilter, { filterList, sortByAwardedLatest, sortByAwardedOldest, sortByLevelHighest, sortByLevelLowest } from './badge-filter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useProps = function useProps(props) {
  var _useState = useState('dateAwardedLatestFirst'),
      badgeFilter = _useState[0],
      setBadgeFilter = _useState[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return _objectSpread({
    handleBadgeFilter: function handleBadgeFilter(evt) {
      var selected = evt.target.value;
      var value = selected in filterList ? selected : 'dateAwardedLatestFirst';
      return setBadgeFilter(value);
    },
    badgeFilter: badgeFilter,
    t: t
  }, props);
};

var BadgeList = function BadgeList(_ref) {
  var badges = _ref.badges;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap'
    },
    "data-element": "Box",
    "data-component": "BadgeList",
    "data-source-file": "index.tsx",
    children: badges.map(function (badge) {
      return /*#__PURE__*/_jsx(Box, {
        sx: {
          mb: 1,
          mr: 2
        },
        children: /*#__PURE__*/_jsx(Badge, {
          badgeProgression: {
            badge: badge,
            badgeProgress: null,
            earnedDate: badge.earnedDate
          }
        })
      }, badge.name);
    })
  });
};

var LevelsList = function LevelsList(_ref2) {
  var badges = _ref2.badges,
      badgeFilter = _ref2.badgeFilter;
  return pipe(badges, NEA.groupBy(function (badge) {
    var _badge$level;

    return ((_badge$level = badge.level) === null || _badge$level === void 0 ? void 0 : _badge$level.id) || 'other';
  }), function (_ref3) {
    var other = _ref3.other,
        levels = _objectWithoutProperties(_ref3, _excluded);

    return /*#__PURE__*/_jsxs(Box, {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        mt: 2
      },
      children: [pipe(Object.values(levels), A.sort(badgeFilter === 'levelLowestFirst' ? sortByLevelLowest : sortByLevelHighest), A.mapWithIndex(function (key, level) {
        var _level$0$level;

        return /*#__PURE__*/_jsxs(Box, {
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h4",
            children: (_level$0$level = level[0].level) === null || _level$0$level === void 0 ? void 0 : _level$0$level.name
          }), /*#__PURE__*/_jsx(BadgeList, {
            badges: level
          })]
        }, key);
      })), other && /*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(Typography, {
          variant: "h4",
          children: /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return t('Other badges');
            }
          })
        }), /*#__PURE__*/_jsx(BadgeList, {
          badges: other
        })]
      })]
    });
  });
};

var PureBadgesEarned = function PureBadgesEarned(_ref4) {
  var badges = _ref4.badges,
      handleBadgeFilter = _ref4.handleBadgeFilter,
      badgeFilter = _ref4.badgeFilter,
      t = _ref4.t;
  var defaultEarnedDate = formatISO(new Date());
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column'
    },
    "data-element": "Box",
    "data-component": "PureBadgesEarned",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(Typography, {
      variant: "h4",
      "data-element": "Typography",
      "data-component": "PureBadgesEarned",
      "data-source-file": "index.tsx",
      children: t('Badges earned')
    }), A.isEmpty(badges) ? /*#__PURE__*/_jsx(Typography, {
      children: t('You do not have any badges yet.')
    }) : /*#__PURE__*/_jsxs(FormControl, {
      sx: {
        mt: 2
      },
      margin: "dense",
      children: [/*#__PURE__*/_jsx(InputLabel, {
        id: "badge-filter",
        children: t('Sort')
      }), /*#__PURE__*/_jsx(BadgeFilter, {
        handleBadgeFilter: handleBadgeFilter,
        badgeFilter: badgeFilter
      })]
    }), (badgeFilter === 'levelLowestFirst' || badgeFilter === 'levelHighestFirst') && A.isNonEmpty(badges) ? /*#__PURE__*/_jsx(LevelsList, {
      badges: badges,
      badgeFilter: badgeFilter
    }) : /*#__PURE__*/_jsx(Box, {
      sx: {
        mt: 2
      },
      children: /*#__PURE__*/_jsx(BadgeList, {
        badges: pipe(badges, A.map(function (b) {
          var _b$earnedDate;

          return _objectSpread(_objectSpread({}, b), {}, {
            earnedDate: (_b$earnedDate = b.earnedDate) !== null && _b$earnedDate !== void 0 ? _b$earnedDate : defaultEarnedDate
          });
        }), A.sort(badgeFilter === 'dateAwardedLatestFirst' ? sortByAwardedLatest : sortByAwardedOldest))
      })
    })]
  });
};

export var BadgesEarned = flow(useProps, PureBadgesEarned);